import { PROVIDER_SURGE_INCENTIVE_UPDATE_SEARCH_FILTERS, PROVIDER_SURGE_INCENTIVE_CREATE_REQUEST } from '../action-types';

export const DEFAULT_STATE = {
  start_date: undefined,
  state_code: undefined,
  active: undefined,
  per_page: 10,
  page: 1,
  context_code: 'PROVIDERINCENTIVECONTEXT_OPEN'
};

const updateSearchFilters = (state, action) => ({
  ...state,
  ...action.payload.filters
});

const updateFiltersOnIncentiveCreate = (state, action) => ({
  ...state,
  page: 1
});

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case PROVIDER_SURGE_INCENTIVE_UPDATE_SEARCH_FILTERS:
      return updateSearchFilters(state, action);
    case PROVIDER_SURGE_INCENTIVE_CREATE_REQUEST.SUCCESS:
      return updateFiltersOnIncentiveCreate(state, action)
    default:
      return state;
  }
};
